module.exports = __webpack_public_path__ + "static/media/quizS.3534d3c8.png";